/**
 * Join items into a readable phrase: `a`, `a or b`, `a, b, or c` — with the
 * Oxford comma from three items onward.
 */
export function joinWithConjunction(
  items: string[],
  conjunction: "and" | "or",
): string {
  if (items.length <= 1) {
    return items[0] ?? "";
  }
  if (items.length === 2) {
    return `${items[0]} ${conjunction} ${items[1]}`;
  }

  const last = items[items.length - 1];
  return `${items.slice(0, -1).join(", ")}, ${conjunction} ${last}`;
}
